import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { ShoppingWithSocial } from './ShoppingWithSocial';
import { ShoppingWithMobileDescription } from './ShoppingWithMobileDescription';
import { ShoppingWithLinks } from './ShoppingWithLinks';
import styles from './styles/ShoppingWithTopModule.scss';

function ShoppingWithTopModuleComponent({ shoppingWith, onOpenAllShoppers, isMobile }) {
    const mobileImage = shoppingWith.mobileImage || shoppingWith.mainImage;

    return (
        <div className={styles.wrapper}>
            <div data-tn="saturday-shopper-main-img-wrapper" className={styles.imageWrapper}>
                {isMobile ? (
                    <img className={styles.mobileImage} src={mobileImage} />
                ) : (
                    <img className={styles.mainImage} src={shoppingWith.mainImage} />
                )}
            </div>
            <div className={styles.detailsWrapper}>
                <div className={styles.titleWrapper}>
                    <h2
                        data-tn="saturday-shopper-title"
                        className={styles.title}
                        dangerouslySetInnerHTML={{ __html: shoppingWith.title }}
                    />
                    <h3
                        data-tn="saturday-shopper-subtitle"
                        className={styles.subTitle}
                        dangerouslySetInnerHTML={{ __html: shoppingWith.subTitle }}
                    />
                </div>
                {isMobile ? (
                    <div>
                        <ShoppingWithMobileDescription
                            shoppingWith={shoppingWith}
                            onOpenAllShoppers={onOpenAllShoppers}
                        />
                    </div>
                ) : (
                    <div>
                        <div
                            className={styles.description}
                            dangerouslySetInnerHTML={{ __html: shoppingWith.description }}
                            data-tn="saturday-shopper-description"
                        />
                        <div className={styles.footer}>
                            <ShoppingWithSocial shoppingWith={shoppingWith} />
                        </div>
                        <div className={styles.footer}>
                            <ShoppingWithLinks shoppingWith={shoppingWith} />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

ShoppingWithTopModuleComponent.propTypes = {
    isMobile: PropTypes.bool.isRequired,
    shoppingWith: PropTypes.object.isRequired,
    onOpenAllShoppers: PropTypes.func.isRequired,
};

export const ShoppingWithTopModule = createFragmentContainer(ShoppingWithTopModuleComponent, {
    shoppingWith: graphql`
        fragment ShoppingWithTopModule_shoppingWith on ShoppingWith {
            ...ShoppingWithSocial_shoppingWith
            ...ShoppingWithMobileDescription_shoppingWith
            ...ShoppingWithLinks_shoppingWith
            mainImage
            mobileImage
            description
            title
            subTitle
        }
    `,
});
